import loadable from '@loadable/component';

const LoadableEncounterDetailsContent = loadable(() => import('./encounterDetailsTooltipContent'));

export default LoadableEncounterDetailsContent;
